import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';
import { KnmErknmStatusCodesEnum } from 'APIPackage/CatalogsModule/enums/KnmErknmStatusCodesEnum';

import { IPublishRulesPmForm } from '../interfaces/IPublishRulesPmForm';
import { IPublishRulesTreeItem } from '../interfaces/IPublishRulesTreeItem';
import { PublishRulesCategoriesEnum } from '../enums/publishRulesCategoriesEnum';
import { getPublishDeadlineOptions } from './getPublishDeadlineOptions';
import { PublishRulesDeadlineModesEnum } from '../enums/publishRulesDeadlineModesEnum';

export const getPublishRulesPmFormInitialValues: (
  treeItem: IPublishRulesTreeItem,
  pmStatusesSelectOptions?: ISelectOption[],
) => IPublishRulesPmForm = (treeItem, pmStatusesSelectOptions) => {
  const publishDeadlineImmediatelyOption = getPublishDeadlineOptions().find(
    item => item.value === PublishRulesDeadlineModesEnum.IMMEDIATELY,
  );

  const waitingCarryOutPmStatusOption = pmStatusesSelectOptions?.find(
    item => item.value === KnmErknmStatusCodesEnum.TYPE_WAITING_CARRY_OUT,
  );

  const remarkPmStatusOption = pmStatusesSelectOptions?.find(item => item.value === KnmErknmStatusCodesEnum.REMARK);

  switch (treeItem.category) {
    case PublishRulesCategoriesEnum.PM_PP:
      return {
        uponAttainingStatus: waitingCarryOutPmStatusOption ? [waitingCarryOutPmStatusOption] : undefined,
        publishDeadline: publishDeadlineImmediatelyOption,
        additionalSettings: [],
      };
    case PublishRulesCategoriesEnum.PM_OP:
      return {
        uponAttainingStatus: remarkPmStatusOption ? [remarkPmStatusOption] : undefined,
        publishDeadline: publishDeadlineImmediatelyOption,
        additionalSettings: [],
      };
    default:
      return { uponAttainingStatus: undefined, publishDeadline: undefined, additionalSettings: [] };
  }
};
